import moment from 'moment';
import React from 'react'
import { useHistory } from 'react-router-dom'

export function TelrPaymentDetails() {

    const history = useHistory();
    const userDetail = history.location.state;

    console.log("userDetail .....", userDetail)

    let date = Date(userDetail.initial_payment_details?.payment_response?.order?.transaction.date)

    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12 my-4">
                                <h3 className="mb-3 d-flex align-items-center"><b>Token ID - {userDetail.quote_token}</b></h3>

                            </div>

                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-12 col-md-6">
                                        <div className="card p-3">
                                            <div className="row">
                                                <div className="col-lg-3 col-md-4 border-end">
                                                    <div className="iconImg my-3 m-auto">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                                                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        <h5 className="mb-0 text-center">{userDetail.job_details.customer_details.name}</h5>

                                                        <p className="mb-0 text-center"> Amount Paid -  <span style={{ fontSize: "24px", fontWeight: "bold" }}>AED {userDetail.initial_payment_details?.payment_response?.order?.amount}</span>  </p>
                                                    </div>
                                                </div>


                                                <div className="col-lg-8 ps-md-4 col-md-6">

                                                    <table width="100%">
                                                        <tbody>
                                                            <tr>
                                                                <td className="py-1">Job No.</td>
                                                                <td>-</td>
                                                                <td className="py-1">{userDetail.job_details.job_token}</td>
                                                            </tr>


                                                            <tr>
                                                                <td className="py-1">Email </td>
                                                                <td>-</td>
                                                                <td className="py-1">{userDetail.job_details.customer_details.email}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Contact No. </td>
                                                                <td>-</td>
                                                                <td className="py-1">{userDetail.job_details.customer_details.mobile_number}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1" style={{ width: 150 }}>Date of Receipt </td>
                                                                <td>-</td>
                                                                <td className="py-1">{moment(date).format("DD-MM-YYYY")}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-1">Payment Method</td>
                                                                <td>-</td>
                                                                <td className="py-1">{userDetail.initial_payment_details?.payment_response?.order?.paymethod}</td>
                                                            </tr>

                                                            <tr>
                                                                <td className="py-1">Status</td>
                                                                <td>-</td>
                                                                <td> <span className="font-size-12">{userDetail.job_details.payment_information.payment_status}</span> </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div >
                </div >
            </div >
        </div >
    )
}



